import { Spin } from 'antd';
import Button from 'antd/es/button';
import { useMemo } from 'react';
import { useTranslate } from '@tolgee/react';
import useTranslationToggle from './useTranslationToggle';

type HookParams = Parameters<typeof useTranslationToggle>;
type RenderProps = ReturnType<typeof useTranslationToggle>;

export interface TranslateTogglerProps {
  text: HookParams[0];
  defaultMap: HookParams[1];
  reporter?: HookParams['2'];
  children?: (props: RenderProps, originText: HookParams[0]) => React.ReactElement;
  showTrans?: boolean;
}

const TranslateToggler = ({
  text,
  defaultMap,
  reporter,
  children,
  showTrans,
}: TranslateTogglerProps) => {
  const toogleProps = useTranslationToggle(text, defaultMap, reporter, showTrans);
  const { pending, error, displayText, displayTranslation, doTrans, showOrigin, showTranslation } =
    toogleProps;
  const { t } = useTranslate();

  const button = useMemo(() => {
    let btnText;
    let onClick;
    if (error) {
      btnText = t('Entities.翻译失败');
      onClick = doTrans;
    } else {
      btnText = t(`trade.${displayTranslation ? '查看原文' : '查看翻译'}`);
      onClick = displayTranslation ? showOrigin : showTranslation;
    }
    return (
      <span>
        <Button type="link" size="small" onClick={onClick}>
          {btnText}
        </Button>
      </span>
    );
  }, [error, displayTranslation, doTrans, showOrigin, showTranslation, t]);

  return children ? (
    children(toogleProps, text)
  ) : (
    <Spin spinning={pending}>
      <span>{pending || error ? text : displayText}</span>
      {button}
    </Spin>
  );
};
export default TranslateToggler;
